<template>
    <!-- 销售发货单 -->
    <div>
        <!-- 功能按钮 -->
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @del="delall" @exps="exp" @print="print" @save="save" @imp="imp"
                    @execute="exered" ref="SetBtn"></buttonlist>
        <!-- 功能按钮 -->
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight  + 'px' }">
            <li class="left" ref="left">
                <div style="display: flex;margin-top: 2px">
                    <el-button type="primary" size="mini" @click="combinePrint" :disabled="selectData.length < 1">{{$t('getapi[2855]')}}</el-button>
                    <el-button type="primary" size="mini" @click="updateSignTime" :disabled="selectData.length < 1">{{$t('getapi[6486]')}}</el-button>
                    <el-upload
                            class="upload-demo"
                            ref="upload"
                            action=""
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :on-change="handleChange"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :http-request="uploadFile"
                            :auto-upload="true"
                            style="margin-left: 8px;"
                            :disabled="!btn.upload"
                            :file-list="fileList"
                    >
                        <el-button type="primary" size="mini" :disabled="!btn.upload">{{$t('getapi[6487]')}}
                        </el-button>
                    </el-upload>
                    <el-button type="primary" size="mini" @click="delPrint" :disabled="!btn.delprint" style="margin-left: 8px">{{$t('getapi[6488]')}}</el-button>
                </div>
                <!-- 功能按钮 -->
                <el-tabs v-model="act" @tab-click="handleClick">
                    <el-tab-pane :label="$t('getapi[2856]')" name="0"></el-tab-pane>
                    <el-tab-pane :label="$t('getapi[2857]')" name="1"></el-tab-pane>
                    <el-tab-pane :label="$t('getapi[2858]')" name="2"></el-tab-pane>
                    <el-tab-pane :label="$t('getapi[2859]')" name="3"></el-tab-pane>
                </el-tabs>
                <!-- 表格 -->
                <wTable id="xpane-0" :data="datajson" ref="singleTable" :loading="loading"
                        queryData="SALShipNoteMasterHeadViewInfo"
                        :filter_language="['StatusName','Verify_Status','Negative_Flag','Finance_Status','Status']"
                        :filter_thousandth="['Delivery_Leadtime']"
                        :filter_date="['Delivery_Date']"
                        :header="tableHeader"  :option="tableOption"   @handleSelectionChange="handleSelectionChange" @edits="edits" @rowdblclick="openEdit" @lct="lct">
                </wTable>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <!-- 编辑弹框 -->
                <div>
                    <div  class="btnnowrap">
                        <el-button type="primary" size="mini" @click.native="notic" :disabled="!btn.notic">{{$t('getapi[2914]')}}
                        </el-button>
                        <el-button type="primary" size="mini" @click.native="creatred" :disabled="!btn.creatred">
                            {{$t('getapi[2916]')}}
                        </el-button>
                        <el-button type="primary" size="mini" @click.native="closse" :disabled="!btn.closse">{{$t('getapi[3601]')}}
                        </el-button>
                        <el-button type="primary" size="mini" @click="UpdateInvoiceQty" :disabled="!updateInvQty">{{
                        $t('getapi[12272]') }}
                    </el-button>
                    </div>
                    <div style="width:1000px;min-width: 1000px">
                        <table>
                            <tr>
                                <td style="width:80px;min-width: 80px"><span>{{ $t('getapi[2292]') }}</span></td>
                                <td style="width:120px;min-width: 120px">
                                    <el-input v-model="formInline.Head.exclusively_id" :placeholder="$t('getapi[2292]')"
                                              size="mini" :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:80px;min-width: 80px"><span>{{ $t('getapi[552]') }}</span></td>
                                <td style="width:120px;min-width: 120px">
                                    <el-input :value="expStatus(formInline.Head.status)" :placeholder="$t('getapi[552]')"
                                              size="mini" :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:80px;min-width: 80px"><span>{{ $t('getapi[2285]') }}</span></td>
                                <td style="width:120px;min-width: 120px">
                                    <el-input
                                            v-show="formInline.Head.consignment_flag == 0"
                                            :placeholder="$t('getapi[2285]')"
                                            :value="$t('getapi[2314]')"
                                            size="mini"
                                            :readonly="true" class="readO"
                                    ></el-input>
                                    <el-input
                                            v-show="formInline.Head.consignment_flag == 1"
                                            :placeholder="$t('getapi[2285]')"
                                            :value="$t('getapi[1023]')"
                                            size="mini"
                                            :readonly="true" class="readO"
                                    ></el-input>
                                </td>
                                <td style="width:80px;min-width: 80px"><span>{{ $t('getapi[1311]') }}</span></td>
                                <td style="width:120px;min-width: 120px">
                                    <el-input v-model="formInline.Head.create_person" :placeholder="$t('getapi[1311]')"
                                              size="mini" :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:80px;min-width: 80px"><span>{{ $t('getapi[1862]') }}</span></td>
                                <td style="width:120px;min-width: 120px">
                                    <el-input
                                            v-show="formInline.Head.finance_status == 0"
                                            :placeholder="$t('getapi[1862]')"
                                            :value="$t('getapi[1901]')"
                                            style="width: 120px"
                                            size="mini"
                                            :readonly="true" class="readO"
                                    ></el-input>
                                    <el-input
                                            v-show="formInline.Head.finance_status == 1"
                                            :placeholder="$t('getapi[1862]')"
                                            :value="$t('getapi[1868]')"
                                            style="width: 120px"
                                            size="mini"
                                            :readonly="true" class="readO"
                                    ></el-input>
                                    <el-input
                                            v-show="formInline.Head.finance_status == 2"
                                            :placeholder="$t('getapi[1862]')"
                                            :value="$t('getapi[1273]')"
                                            style="width: 120px"
                                            size="mini"
                                            :readonly="true" class="readO"
                                    ></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td><span>{{ $t('getapi[2882]') }}</span></td>
                                <td>
                                    <routejump :urlNo="39" v-show="formInline.Lists <= 0">
                                    <el-input
                                            v-model="formInline.Head.customer_order"
                                            :placeholder="$t('getapi[2882]')"
                                            class="mcolor"
                                            size="mini"
                                            readonly
                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="conopen"></i>
                                    </el-input>
                                    </routejump>
                                    <el-input
                                            class="mcolor"
                                            v-show="formInline.Lists.length > 0"
                                            v-model="formInline.Head.customer_order"
                                            :placeholder="$t('getapi[2882]')"
                                            style="width:120px"
                                            size="mini"
                                            readonly
                                    ></el-input>
                                </td>
                                <td><span >{{ $t('getapi[2881]') }}</span></td>
                                <td>
                                    <el-date-picker
                                            v-model="formInline.Head.delivery_date"
                                            type="date"
                                            :placeholder="$t('getapi[2881]')"
                                            format="yyyy-MM-dd"
                                            value-format="yyyy-MM-dd"
                                            style="width: 100%"
                                            class="mcolor"
                                            size="mini"
                                            :readonly="formInline.Head.status== 2"
                                    ></el-date-picker>
                                </td>
                                <td><span >{{ $t('getapi[135]') }}</span></td>
                                <td><el-input v-model="formInline.Head.create_time" :placeholder="$t('getapi[135]')"
                                              size="mini" :readonly="true" class="readO"></el-input></td>
                                <td><span>{{ $t('getapi[6489]') }}</span></td>
                                <td><el-input v-model="formInline.Head.finance_date" :placeholder="$t('getapi[6489]')"
                                              size="mini" :readonly="true" class="readO"></el-input></td>
                                <td colspan="2">
                                    <el-checkbox disabled v-model="formInline.Head.invoice_flag" :true-label="1" :false-label="0">{{ $t('getapi[1865]') }}
                                    </el-checkbox>
                                </td>
                            </tr>
                            <tr>
                                <td><span>{{ $t('getapi[2584]') }}</span></td>
                                <td colspan="3">
                                    <el-input v-model="formInline.Head.customer_name" :placeholder="$t('getapi[2584]')"
                                              size="mini" :readonly="true" class="readO"></el-input>
                                </td>
                                <td><span >{{ $t('getapi[2786]') }}</span></td>
                                <td>
                                    <routejump :urlNo="6">
                                    <el-input
                                            v-model="formInline.Head.delivery_person"
                                            :placeholder="$t('getapi[2786]')"
                                            class="mcolor"
                                            readonly
                                            size="mini"
                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="peop(6)"></i>
                                    </el-input>
                                    </routejump>
                                </td>
                                <td><span>{{ $t('getapi[2876]') }}</span></td>
                                <td>
                                    <el-input v-model="formInline.Head.base_order_no" :placeholder="$t('getapi[2876]')"
                                              size="mini" :readonly="true" class="readO"></el-input>
                                </td>
                                <td colspan="2">
                                    <el-checkbox disabled v-model="formInline.Head.issue_part_flow" :true-label=1 :false-label=0>{{ $t('getapi[2284]') }}</el-checkbox>
                                </td>
                            </tr>
                            <tr>
                                <td><span>{{ $t('getapi[1866]') }}</span></td>
                                <td>
                                    <el-select class="mcolor" v-model="formInline.Head.order_category" size="mini"
                                               style="width: 120px;">
                                        <el-option v-if="formInline.Head.negative_flag == 0" value="发货" :label="$t('getapi[2713]')"></el-option>
                                        <el-option v-if="formInline.Head.negative_flag != 0" value="退货" :label="$t('getapi[1950]')"></el-option>
                                        <el-option value="换货" :label="$t('getapi[2902]')"></el-option>
                                        <el-option value="调账" :label="$t('getapi[2903]')"></el-option>
                                    </el-select>
                                </td>
                                <td><span >{{ $t('getapi[4472]') }}</span></td>
                                <td>
                                    <routejump :urlNo="6">
                                    <el-input
                                            v-model="formInline.Head.keep_person"
                                            :placeholder="$t('getapi[4472]')"
                                            style="width: 120px"
                                            class="mcolor"
                                            readonly
                                            size="mini"
                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="peop(5)"></i>
                                    </el-input>
                                    </routejump>
                                </td>
                                <td><span>{{ $t('getapi[4473]') }}</span></td>
                                <td>
                                    <routejump :urlNo="6">
                                    <el-input
                                            v-model="formInline.Head.regist_person"
                                            :placeholder="$t('getapi[4473]')"
                                            style="width: 120px"
                                            class="mcolor"
                                            readonly
                                            size="mini"
                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="peop(4)"></i>
                                    </el-input>
                                    </routejump>
                                </td>
                                <td><span>{{ $t('getapi[2872]') }}</span></td>
                                <td>
                                    <el-input
                                            v-show="formInline.Head.verify_status == 0"
                                            :placeholder="$t('getapi[2872]')"
                                            :value="$t('getapi[2053]')"
                                            style="width: 120px"
                                            size="mini"
                                            :readonly="true" class="readO"
                                    ></el-input>
                                    <el-input
                                            v-show="formInline.Head.verify_status == 1"
                                            :placeholder="$t('getapi[2872]')"
                                            :value="$t('getapi[2052]')"
                                            style="width: 120px"
                                            size="mini"
                                            :readonly="true" class="readO"
                                    ></el-input>
                                </td>
                                <td>
                                    <el-checkbox disabled v-model="formInline.Head.negative_flag" :true-label="1" :false-label="0">{{ $t('getapi[2096]') }}</el-checkbox>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <!--<div class="box" style="margin-top:5px" >
                        <div class="bbl">
                            <span>{{ $t('getapi[2292]') }}</span>
                            <el-input v-model="formInline.Head.exclusively_id" :placeholder="$t('getapi[2292]')"
                                    style="width: 120px" size="mini" :readonly="true" class="readO"></el-input>
                            <span>{{ $t('getapi[552]') }}</span>
                            <el-input :value="expStatus(formInline.Head.status)" :placeholder="$t('getapi[552]')"
                                    style="width: 120px" size="mini" :readonly="true" class="readO"></el-input>
                            <span>{{ $t('getapi[2285]') }}</span>
                            <el-input
                                    v-show="formInline.Head.consignment_flag == 0"
                                    :placeholder="$t('getapi[2285]')"
                                    :value="$t('getapi[2314]')"
                                    style="width: 120px"
                                    size="mini"
                                    :readonly="true" class="readO"
                            ></el-input>
                            <el-input
                                    v-show="formInline.Head.consignment_flag == 1"
                                    :placeholder="$t('getapi[2285]')"
                                    :value="$t('getapi[1023]')"
                                    style="width: 120px"
                                    size="mini"
                                    :readonly="true" class="readO"
                            ></el-input>

                            <span>{{ $t('getapi[1311]') }}</span>
                            <el-input v-model="formInline.Head.create_person" :placeholder="$t('getapi[1311]')"
                                    style="width: 120px" size="mini" :readonly="true" class="readO"></el-input>
                            <span>{{ $t('getapi[1862]') }}</span>
                            <el-input v-show="formInline.Head.finance_status == -1" :placeholder="$t('getapi[1862]')"
                                    style="width: 120px" size="mini" :readonly="true" class="readO"></el-input>
                            <el-input
                                    v-show="formInline.Head.finance_status == 0"
                                    :placeholder="$t('getapi[1862]')"
                                    :value="$t('getapi[1901]')"
                                    style="width: 120px"
                                    size="mini"
                                    :readonly="true" class="readO"
                            ></el-input>
                            <el-input
                                    v-show="formInline.Head.finance_status == 1"
                                    :placeholder="$t('getapi[1862]')"
                                    :value="$t('getapi[1868]')"
                                    style="width: 120px"
                                    size="mini"
                                    :readonly="true" class="readO"
                            ></el-input>
                            <el-input
                                    v-show="formInline.Head.finance_status == 2"
                                    :placeholder="$t('getapi[1862]')"
                                    :value="$t('getapi[1273]')"
                                    style="width: 120px"
                                    size="mini"
                                    :readonly="true" class="readO"
                            ></el-input>
                        </div>
                        <div class="bbl">
                            <span>{{ $t('getapi[2882]') }}</span>
                            <el-input
                                    v-show="formInline.Lists <= 0"
                                    v-model="formInline.Head.customer_order"
                                    :placeholder="$t('getapi[2882]')"
                                    style="width:120px"
                                    class="mcolor"
                                    size="mini"
                                    readonly
                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="conopen"></i>
                            </el-input>
                            <el-input
                                    class="mcolor"
                                    v-show="formInline.Lists.length > 0"
                                    v-model="formInline.Head.customer_order"
                                    :placeholder="$t('getapi[2882]')"
                                    style="width:120px"
                                    size="mini"
                                    readonly
                            ></el-input>
                            <span >{{ $t('getapi[2881]') }}</span>
                            <el-date-picker
                                    v-model="formInline.Head.delivery_date"
                                    type="date"
                                    :placeholder="$t('getapi[2881]')"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                    style="width: 120px"
                                    class="mcolor"
                                    size="mini"
                                    :readonly="formInline.Head.status== 2"
                            ></el-date-picker>
                           
                            <span >{{ $t('getapi[135]') }}</span>
                            <el-input v-model="formInline.Head.create_time" :placeholder="$t('getapi[135]')"
                                    style="width: 120px" size="mini" :readonly="true" class="readO"></el-input>
                            <span>{{ $t('getapi[6489]') }}</span>
                            <el-input v-model="formInline.Head.finance_date" :placeholder="$t('getapi[6489]')"
                                    style="width: 120px" size="mini" :readonly="true" class="readO"></el-input>
                            <el-checkbox disabled v-model="formInline.Head.invoice_flag" :true-label="1" :false-label="0"
                                        style="margin-left: 20px;">{{ $t('getapi[1865]') }}
                            </el-checkbox>
                        </div>
                        <div class="bbl">
                            <span>{{ $t('getapi[2584]') }}</span>
                            <el-input v-model="formInline.Head.customer_name" :placeholder="$t('getapi[2584]')"
                                    style="width: 320px" size="mini" :readonly="true" class="readO"></el-input>
                            <span >{{ $t('getapi[2786]') }}</span>
                            <el-input
                                    v-model="formInline.Head.delivery_person"
                                    :placeholder="$t('getapi[2786]')"
                                    style="width: 120px"
                                    class="mcolor"
                                    readonly
                                    size="mini"
                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="peop(6)"></i>
                            </el-input>
                            <span>{{ $t('getapi[2876]') }}</span>
                            <el-input v-model="formInline.Head.base_order_no" :placeholder="$t('getapi[2876]')"
                                    style="width: 120px" size="mini" :readonly="true" class="readO"></el-input>
                            <el-checkbox disabled v-model="formInline.Head.issue_part_flow" :true-label=1 :false-label=0>{{ $t('getapi[2284]') }}</el-checkbox>
                            
                        </div>
                        <div class="bbl">
                            <span>{{ $t('getapi[1866]') }}</span>
                            <el-select class="mcolor" v-model="formInline.Head.order_category" size="mini"
                                    style="width: 120px;">
                                <el-option v-if="formInline.Head.negative_flag == 0" value="发货" :label="$t('getapi[2713]')"></el-option>
                                <el-option v-if="formInline.Head.negative_flag != 0" value="退货" :label="$t('getapi[1950]')"></el-option>
                                <el-option value="换货" :label="$t('getapi[2902]')"></el-option>
                                <el-option value="调账" :label="$t('getapi[2903]')"></el-option>
                            </el-select>
                            <span >{{ $t('getapi[4472]') }}</span>
                            <el-input
                                    v-model="formInline.Head.keep_person"
                                    :placeholder="$t('getapi[4472]')"
                                    style="width: 120px"
                                    class="mcolor"
                                    readonly
                                    size="mini"
                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="peop(5)"></i>
                            </el-input>                            
                            <span>{{ $t('getapi[4473]') }}</span>
                            <el-input
                                    v-model="formInline.Head.regist_person"
                                    :placeholder="$t('getapi[4473]')"
                                    style="width: 120px"
                                    class="mcolor"
                                    readonly
                                    size="mini"
                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="peop(4)"></i>
                            </el-input>
                            <span>{{ $t('getapi[2872]') }}</span>
                            <el-input
                                    v-show="formInline.Head.verify_status == 0"
                                    :placeholder="$t('getapi[2872]')"
                                    :value="$t('getapi[2053]')"
                                    style="width: 120px"
                                    size="mini"
                                    :readonly="true" class="readO"
                            ></el-input>
                            <el-input
                                    v-show="formInline.Head.verify_status == 1"
                                    :placeholder="$t('getapi[2872]')"
                                    :value="$t('getapi[2052]')"
                                    style="width: 120px"
                                    size="mini"
                                    :readonly="true" class="readO"
                            ></el-input>
                            
                            <el-checkbox disabled v-model="formInline.Head.negative_flag" :true-label="1" :false-label="0">{{ $t('getapi[2096]') }}</el-checkbox>
                            
                        </div>
                        &lt;!&ndash; <div class="bbl">
                            <span>{{ $t('getapi[143]') }}</span>
                            <el-input v-model="formInline.Head.remark" :placeholder="$t('getapi[143]')"
                                    style="width: 320px" size="mini" ></el-input>
                        </div> &ndash;&gt;
                    </div>-->
                    <el-tabs>
                        <el-tab-pane :label="$t('getapi[7958]')">
                            <div class="box">
                                <div class="bbl">
                                    <el-button type="primary" size="mini"
                                                @click="addlines" :disabled="!btn.rowadd">{{$t('getapi[878]')}}
                                    </el-button>
                                    <el-button type="primary" size="mini"
                                                @click="dellines" :disabled="!btn.rowdel">{{$t('getapi[3889]')}}
                                    </el-button>
                                </div>
                            </div>
                            <el-table
                                    id="xdetilpane-0"
                                    :data="formInline.Lists"
                                    @selection-change="linedelsel"
                                    border
                                    :height="tableHeight - 200"
                                    size="mini"
                                    header-row-class-name="headerclass"
                                    style="width: 100%;margin-top: 2px"
                                    @sort-change="sortChange"
                                    :row-class-name="tableRowClassName"
                                    ref="singleTable1"
                            >
                                <el-table-column type="selection" width="20"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[1425]')" sortable
                                                    align="right" width="60"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="co_line_no" :label="$t('getapi[3600]')" sortable
                                                    align="right" width="60"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="pnid" :label="$t('getapi[2287]')" sortable
                                width="100" ></el-table-column>
                                <el-table-column show-overflow-tooltip prop="pn_line_id" :label="$t('getapi[6490]')" sortable
                                                    width="100" v-if="false"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="pn_line_no" :label="$t('getapi[2845]')" sortable
                                                    align="right" width="60"></el-table-column>
                                <el-table-column prop="sales_part" :label="$t('getapi[2800]')" sortable
                                                    width="120">
                                    <template slot-scope="scope" v-show="editf">
                                        <el-input
                                                class="mcolor"
                                                v-model="scope.row.sales_part"
                                                :placeholder="$t('getapi[2800]')"
                                                readonly
                                        >
                                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="ssf(scope)"></i>
                                        </el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="qty_onhand" :label="$t('getapi[2920]')" sortable
                                                    align="right" width="80"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[3940]')" sortable
                                                    width="80"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_cur_version"
                                                    :label="$t('getapi[2654]')" sortable width="80"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="spec" :label="$t('getapi[125]')" sortable  width="80"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="model" :label="$t('getapi[124]')" sortable  width="80"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="page_no" :label="$t('getapi[133]')" sortable  width="80"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="pnqty" :label="$t('getapi[2831]')" sortable
                                                    align="right" width="80"></el-table-column>
                                
                                <el-table-column show-overflow-tooltip prop="sales_unit" :label="$t('getapi[2658]')" sortable
                                                    width="80"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="unit_price" :label="$t('getapi[2186]')" sortable
                                                    align="right" width="80"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="line_net_total_amount"
                                                    :label="$t('getapi[2187]')" sortable align="right"
                                                    width="80"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="t_cuspart_id"
                                                    :label="$t('getapi[2390]')" sortable width="80"></el-table-column>
                                
                                <el-table-column show-overflow-tooltip prop="exchange_rate"
                                                    :label="$t('getapi[1304]')" sortable align="right"
                                                    width="80"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="inv_measureunit"
                                                    :label="$t('getapi[1340]')" sortable width="80"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="inv_measure_issue_qty"
                                                    :label="$t('getapi[2879]')" align="right"
                                                    width="80"></el-table-column>
                                <el-table-column prop="qty_delivered"
                                                    :label="$t('getapi[2821]')" sortable align="right"
                                                    width="80">
                                    <template scope="scope">
                                        <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                                    v-model="scope.row.qty_delivered" @change="getinv_measure_issue_qty(scope)" v-show="formInline.Head.negative_flag == 1"></el-input>
                                        <span v-show="formInline.Head.negative_flag != 1">{{scope.row.qty_delivered}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="weight"
                                                 :label="$t('getapi[13318]')" sortable align="right"
                                                 width="80"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="weights"
                                                 :label="$t('getapi[13319]')" sortable align="right"
                                                 width="80"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="customer_item"
                                                    :label="$t('getapi[2707]')" sortable align="right"
                                                    width="80"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="createinvoiceqty"
                                                    :label="$t('getapi[2003]')" sortable align="right"
                                                    width="80"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="releaseinvoiceqty"
                                                    :label="$t('getapi[2004]')" sortable align="right"
                                                    width="80"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="remark2"
                                                    :label="remark2" sortable align="left"
                                                    width="120"></el-table-column>
                                <el-table-column field="cust_deliverynote_no" :label="$t('getapi[8591]')" sortable width="150">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.cust_deliverynote_no" :placeholder="$t('getapi[8591]')"></el-input>
                                    </template>
                                </el-table-column> 
                                <el-table-column show-overflow-tooltip prop="itemvernum"
                                                    :label="$t('getapi[6700]')" sortable align="left"
                                                    width="120"></el-table-column>
                                <el-table-column field="line_remark" :label="$t('getapi[1509]')" sortable width="150">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.line_remark" :placeholder="$t('getapi[1509]')"></el-input>
                                    </template>
                                </el-table-column> 
                                <el-table-column show-overflow-tooltip prop="cus_chartnum" :label="$t('getapi[8595]')" sortable align="left"
                                                    width="120"></el-table-column>
                                                    
                            </el-table>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[6491]')">
                            <div style="width:600px;min-width: 600px">
                                <table>
                                    <tr>
                                        <td style="width:80px;min-width: 80px"><span>{{ $t('getapi[2693]') }}</span></td>
                                        <td style="width:120px;min-width: 120px">
                                            <el-input v-model="formInline.Head.contract_info"
                                                      :placeholder="$t('getapi[2693]')"
                                                      size="mini"></el-input>
                                        </td>
                                        <td style="width:80px;min-width: 80px"><span>{{ $t('getapi[1217]') }}</span></td>
                                        <td style="width:120px;min-width: 120px">
                                            <routejump :urlNo="38">
                                            <el-select filterable v-model="formInline.Head.transport_type"
                                                       size="mini">
                                                <el-option v-for="item in TransMode" :label="item.TypeName"
                                                           :value="item.TypeName" :key="item.Exclusively_Id"></el-option>
                                            </el-select>
                                            </routejump>
                                        </td>
                                        <td style="width:80px;min-width: 80px"><span>{{ $t('getapi[1295]') }}</span></td>
                                        <td style="width:120px;min-width: 120px">
                                            <el-input
                                                    v-model="formInline.Head.delivery_leadtime"
                                                    :placeholder="$t('getapi[1295]')"
                                                    type="number"
                                                    autocomplete="off" title=""
                                                    @mousewheel.native.prevent
                                                    style="width:100px"
                                                    size="mini"
                                            ></el-input>
                                            {{ $t('getapi[217]') }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><span>{{ $t('getapi[7931]') }}</span></td>
                                        <td colspan="3">
                                            <el-select filterable v-model="formInline.Head.Address_ShortName_Id" @change="getShortNameInfo"
                                                       size="mini" >
                                                <el-option v-for="item in AddressShort" :label="item.Address_ShortName" :value="item.exclusively_id"
                                                           :key="item.exclusively_id"></el-option>
                                            </el-select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><span>{{ $t('getapi[2595]') }}</span></td>
                                        <td colspan="5">
                                            <el-input v-model="formInline.Head.delivery_address"
                                                      :placeholder="$t('getapi[2595]')"
                                                      size="mini"></el-input>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><span>{{ $t('getapi[8051]') }}</span></td>
                                        <td colspan="5">
                                            <el-input type="textarea" v-model="formInline.Head.remark"
                                                      :placeholder="$t('getapi[8051]')"></el-input>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <!--<div class="box">
                                <div class="bbl">
                                    <span>{{ $t('getapi[2693]') }}</span>
                                    <el-input v-model="formInline.Head.contract_info"
                                                :placeholder="$t('getapi[2693]')" style="width:100px"
                                                size="mini"></el-input>
                                    <span>{{ $t('getapi[1217]') }}</span>
                                    <el-select filterable v-model="formInline.Head.transport_type"
                                                style="width: 120px;" size="mini">
                                        <el-option v-for="item in TransMode" :label="item.TypeName"
                                                    :value="item.TypeName" :key="item.Exclusively_Id"></el-option>
                                    </el-select>
                                    <span>{{ $t('getapi[1295]') }}</span>
                                    <el-input
                                            v-model="formInline.Head.delivery_leadtime"
                                            :placeholder="$t('getapi[1295]')"
                                            type="number"
                                            autocomplete="off" title=""
                                            @mousewheel.native.prevent
                                            style="width:100px"
                                            size="mini"
                                    ></el-input>
                                    {{ $t('getapi[217]') }}
                                </div>
                                <div class="bb1">
                                    <span style="margin-left: 10px;">{{ $t('getapi[7931]') }}</span>
                                    <el-select filterable v-model="formInline.Head.Address_ShortName_Id" @change="getShortNameInfo"
                                               style="width: 300px;" size="mini" >
                                        <el-option v-for="item in AddressShort" :label="item.Address_ShortName" :value="item.exclusively_id"
                                                   :key="item.exclusively_id"></el-option>
                                    </el-select>
                                </div>
                                <div class="bbl">
                                    <span>{{ $t('getapi[2595]') }}</span>
                                    <el-input v-model="formInline.Head.delivery_address"
                                                :placeholder="$t('getapi[2595]')" style="width:500px"
                                                size="mini"></el-input>
                                </div>

                                <div class="bbl">
                                    <span>{{ $t('getapi[8051]') }}</span>
                                    <el-input type="textarea" v-model="formInline.Head.remark"
                                                :placeholder="$t('getapi[8051]')" style="width:500px"></el-input>
                                </div>
                            </div>-->
                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[6421]')">
                                <el-upload
                                        class="upload-demo"
                                        ref="upload"                                        
                                        :action="uploadurlfile"
                                        :on-preview="handlePreviewfile"
                                        :on-remove="handleRemovefile"
                                        :on-change="handleChangefile"
                                        :on-success="handleSuccessfile"
                                        :on-error="handleErrorfile"
                                        :before-upload="beforeAvatarUploadfile"
                                        :file-list="outfileList"
                                        :data="outfileparm"
                                        :limit="10"
                                        :auto-upload="false"
                                        :multiple="true"
                                >
                                    <el-button slot="trigger" size="mini" type="primary">{{$t('getapi[6422]')}}</el-button>
                                    <el-button style="margin-left: 10px;" size="mini" type="success" @click="submitUpload">{{$t('getapi[13274]')}}</el-button>
                                    <el-button style="margin-left: 10px;" size="mini" type="warning" @click="clearFileList">{{$t('getapi[13277]')}}</el-button>
                                    <div slot="tip" class="el-upload__tip"></div>
                                </el-upload>
                                <el-table
                                        :data="formInline.outfileList"
                                        v-loading="loading"
                                        :highlight-current-row="false"
                                        show-overflow-tooltip="true"
                                        border
                                        stripe
                                        size="mini"
                                        header-row-class-name="headerclass"
                                >
                                    <el-table-column show-overflow-tooltip prop="Node_Name"
                                                     :label="$t('getapi[3590]')"></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="Doc_Type"
                                                     :label="$t('getapi[6423]')"></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="Doc_Size"
                                                     :label="$t('getapi[7875]')"></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="Upload_Person"
                                                     :label="$t('getapi[6425]')"></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="Upload_Time"
                                                     :label="$t('getapi[6426]')"></el-table-column>
                                    <el-table-column prop="operate" :label="$t('getapi[6048]')">
                                        <template slot-scope="scope">
                                            <el-button @click.native.prevent="openfile(scope)" type="text" size="mini">{{
                                                $t('getapi[3611]') }}
                                            </el-button>
                                            <el-button @click.native.prevent="filedel(scope)" type="text" size="mini">{{
                                                $t('getapi[40]') }}
                                            </el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-tab-pane>
                    </el-tabs>
                </div>
                <!-- 编辑弹框 -->
            </li>
        </ul>
        <!-- 分页 -->
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="PageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>

        <!-- 销售人员 -->
        <!--<employee :isVisible="false" @getemployee="getemployee" ref="inputemp"></employee>-->
        <selector :isVisible="false" :selectType="6" :isSplitPage=true :postUrl="'/Basic/Popup/GetEmployeeDataList'"
                  @callback="getemployee" ref="inputemp1"></selector>
        <selector :isVisible="false" :selectType="3" :isSplitPage=true :postUrl="'/Basic/Popup/GetEmployeeDataList'"
                  @callback="getemployee" ref="inputemp2"></selector>
        <!-- 销售件 -->
        <!--<salpart :isVisible="false" @getsalpart="getsalpart" ref="input"></salpart>-->
        <selector :isVisible="false" :selectType="1" :isSplitPage=true :isBatch="true" :postUrl="'Basic/Popup/GetDeliveryBillDataList'"
                  @callback="getsalpart" ref="input"></selector>
        <selector :isVisible="false" :selectType="1" :isSplitPage=true :postUrl="'Basic/Popup/GetDeliveryBillDataList'"
                  @callback="getsalpart" ref="inputsingle"></selector>
        <selector :isVisible="false" :selectType="0" :isSplitPage=true :postUrl="'Sal/Out/GetSalPickNoticeDateList'"
                  @callback="getsalpart" ref="input4"></selector>
        <!-- 订单 -->
        <!--<salorder :isVisible="false" @getsalorder="getsalorder" ref="inputs"></salorder>-->
        <selector :isVisible="false" :selectType="0" :isSplitPage=true :postUrl="'Basic/Popup/GetDeliveryBillDataList'"
                  @callback="getsalorder" ref="inputs"></selector>
        <!-- 分页 -->
        <serce :isVisible="isVisible" queryData="SALShipNoteMasterHeadViewInfo" ref="ser" @getser="serclick"></serce>
        <!-- 排序 -->
		<ctable :isVisible="false" :title="$t('getapi[6492]')" queryData="SALShipNoteMasterHeadViewInfo" tabNo="0" ref="ctab" @getctab="sortclick"></ctable>

        <el-dialog v-dialogDrag :visible.sync="visPrintType" width="25%" :close-on-click-modal="false">
            <table>
                <tr>
                    <td style="width:100px">
                        <el-radio v-model="print_sort" label="0">{{$t('getapi[6493]')}}</el-radio>
                    </td>
                    <td>
                        <el-radio v-model="print_model" label="0">{{$t('getapi[6494]')}}</el-radio>
                    </td>

                </tr>
                <tr>
                    <td style="width:100px">
                        <el-radio v-model="print_sort" label="1">{{$t('getapi[6495]')}}</el-radio>
                    </td>
                    <td>
                        <el-radio v-model="print_model" label="1">{{$t('getapi[6496]')}}</el-radio>
                    </td>
                </tr>
                <tr>
                    <td style="width:100px">
                    </td>
                    <td>
                        <el-radio v-model="print_model" label="2">{{$t('getapi[8923]')}}</el-radio>
                    </td>
                </tr>
                <tr>
                    <td style="width:100px">
                    </td>
                    <td>
                        <el-radio v-model="print_model" label="3">GMC</el-radio>
                    </td>
                </tr>
                <tr>
                    <td style="width:100px">
                    </td>
                    <td>
                        <el-radio v-model="print_model" label="4">{{$t('getapi[12697]')}}</el-radio>
                    </td>
                </tr>
            </table>
            <span slot="footer" class="dialog-footer">
				<el-button @click="visPrintType = false" size="mini">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="confirmCombinePrint" size="mini">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="visDetailPrintType" width="15%" :close-on-click-modal="false">
            <el-form>
                <el-form-item>
                    <div v-for="(item, index) in dataPrint" :key="index">
                        <el-form-item>
                            <el-radio v-model="radio" :label="item.Num" @change="(val)=>{changePrint(val,item.Code)}">{{item.Name}}</el-radio>
                        </el-form-item>
                    </div>
                </el-form-item>
            </el-form>
            <!--<table v-if="userData.Login_DB.toUpperCase() == 'MY'">
                <tr>
                    <td style="width:100px">
                        <el-radio v-model="print_size" label="0">美宇(有价格)</el-radio>
                    </td>
                    <td style="width:100px">
                        <el-radio v-model="print_size" label="1">锐拓(有价格)</el-radio>
                    </td>
                </tr>
                <tr>
                    <td style="width:100px">
                        <el-radio v-model="print_size" label="3">美宇(无价格)</el-radio>
                    </td>
                    <td style="width:100px">
                        <el-radio v-model="print_size" label="4">锐拓(无价格)</el-radio>
                    </td>
                </tr>
            </table>
            <table v-if="userData.Login_DB.toUpperCase() != 'MY'">
                <tr>
                    <td style="width:100px">
                        <el-radio v-model="print_size" label="0">{{$t('getapi[6497]')}}</el-radio>
                    </td>
                    <td style="width:100px">
                        <el-radio v-model="print_size" label="1">{{$t('getapi[6498]')}}</el-radio>
                    </td>
                </tr>
            </table>-->
            <span slot="footer" class="dialog-footer">
				<el-button @click="visDetailPrintType = false" size="mini">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="confirmPrint" size="mini">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="showPrintData" :title="$t('getapi[6499]')" width="60%">
            <el-table
                    :data="printData"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    stripe
                    size="mini"
                    :height="500"
                    header-row-class-name="headerclass"
                    style="width: 100%; margin-top:0px"
            >
                <el-table-column show-overflow-tooltip prop="Doc_No" :label="$t('getapi[6500]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="Receipt_Time" :label="$t('getapi[6501]')"></el-table-column>
                <el-table-column prop="Receipt_Url" :label="$t('getapi[6502]')">
                    <template slot-scope="scope">
                        <a v-if="scope.row.Receipt_Url != '' && scope.row.Receipt_Url != null" @click="open(scope.row.Receipt_Url)" style="text-decoration:underline;color:blue">{{$t('getapi[6503]')}}</a>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>

        <el-dialog v-dialogDrag
                   :title="$t('getapi[6504]')"
                   :visible.sync="showSignTime"
                   width="15%"
        >
            <el-date-picker v-model="printdate" type="date" size="mini"
                            style="width:100%"></el-date-picker>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="confirmUpdateSignTime()" size="mini">{{$t('getapi[1146]')}}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import { Loading } from 'element-ui';
    import { encryptDes, decryptDes,generatekey } from '@/utils/des.js'
    export default {
        name: 'salshipmentslist',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3-Common.reduceTableHeight1,
                    maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight1,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                formInline: {
                    Head: {
                        exclusively_id: '',
                        customer_order: '',
                        customer_name: '',
                        field: '',
                        delivery_date: '',
                        delivery_person: '',
                        transport_type: '',
                        delivery_leadtime: '',
                        delivery_address: '',
                        create_person: '',
                        create_time: '',
                        status: 0,
                        statusname: '',
                        remark: '',
                        hook_flag: 0,
                        finance_status: 0,
                        finance_date: '',
                        base_order_no: '',
                        negative_flag: 0,
                        verify_status: 0,
                        keep_person: '',
                        regist_person: '',
                        remark_new: '',
                        update_person: '',
                        update_time: '',
                        order_category: '发货',
                        verify_type: 0,
                        inner_no: '',
                        invoice_flag: 0,
                        concurrent_time: '',
                        carrier_name: '',
                        vehicle_size: '',
                        plate_no: '',
                        cmr_no: '',
                        ekaer_no: '',
                        consignment_flag: 0,
                        issue_part_flow: 0,
                        contract_info: '',
                        Address_ShortName_Id: '',
                        Address_ShortName:'',
                    },
                    Lists: [],
                    outfileList:[]
                },
                userData: [],
                oldFormInline:'',
                ids: '',
                userinfo: {},
                SelectIndexs: 1,
                isEdit: true, // 是否新增
                ProPositionList: [],
                act: '0',
                showloading: '',
                isVisible: false,
                editvisi: false,
                DbTbNames: '', //表名
                datajson: [],
                PageIndex: 1,
                PageSize: this.$http.getPageSize('SALShipNoteMasterHeadViewInfo'),
                SelectIndex: 0,
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                reduceTableHeight: Common.reduceTableHeight2,
                isShowEdit: false, // 是否显示编辑页面
                dataSetDetail: {}, // 编辑页面数据详情
                queryData: [], // 查询数组
                selectIDData: '', // 选择的数据的ID集合
                tracetype: 0, //跟踪类别
                url: '', // 零件图路径
                itevisible: false, //物料弹框
                DeliveryTermList: [], //交货条款
                TransMode: [], //运输方式
                rouvisible: false,
                roushowindex: 0,
                wcentervisible: false,
                wcentershowindex: 0,
                selectData: [],
                selectDetailData: [], // 选择的数据的集合
                editf: true,
                partype: 0,
                currentRow: null,
                lineid: [],
                btn: {
                    //打印形式发票
                    prinoice: false,
                    //从CSV文件生成
                    csvf: false,
                    //从通知生成
                    notic: false,
                    //确认关闭
                    closse: false,
                    //执行记账
                    execu: false,
                    //生成红字发货单
                    creatred: false,
                    //执行红字发货单
                    exered: false,
                    //调整财务日期
                    changdata: false,
                    //删除明细
                    rowdel: false,
                    //新增行
                    rowadd: false,
                    upload: false,
                    delprint: false,
                },
                addoredit: 1, // 1:新增2：修改
                order_No: '',
                dataDetailLineNo: 1,
                tableHeader: [],
                oldrow: '',
                iscontinuedblclick: true,
                timeId: null,
                visPrintType: false,
                print_sort: '0',
                print_model: '0',
                visDetailPrintType: false,
                print_size: '0',
                oneormore: 1,
                printData: [],
                showPrintData: false,
                showSignTime: false,
                printdate: '',
                fileList: [],
                file: null,
                code: '',
                remark2:'',//备注2特殊处理
                AddressShort: [], //收货地址简称
                dataPrint: [], //打印模板
                tempname: '',// 选中的模板名称
                radio: '0',
                updateInvQty: false,
                scrollTop:0,
                scrollTop1:0,
                uploadurlfile:'',
                outfileparm: {
                    code: '',
                    data_type: 20,
                    Login_Group:'',
                    Login_DB:'',
                },
                outfileList: [],
            };
        },
        create() {
        },
        beforeMount() {
            // console.log('beforeMount');
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            let token = JSON.parse(that.userData).token;
            that.uploadurlfile = Common.FileUrl+ '/Files/UpFileByDocManage?token=' + token;
        },
        watch: {
            datajson: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        beforeRouteEnter(to, form, next) {
            next(vm => {
                if (form.name == 'salelin' && Object.keys(vm.$store.state.sharedParams).length > 0) {
                    const data = {...vm.$store.state.sharedParams};
                    vm.getdlist(data.order_no);
                    setTimeout(() => {
                        vm.openEdit()
                    }, 500);
                    vm.$store.commit('clearSharedParams')
                }
            });
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                }, 13)
            })
        },
        mounted() {
            // console.log('mounted');
            let that = this;
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.colsort();
            that.$processdata.pushModelCache('salshipmentslist', that)
            var users = sessionStorage.getItem('userData');
            that.userinfo = JSON.parse(users);
             that.remark2="备注2";
            if(that.userinfo.Login_DB=="MY"){
                that.remark2="下一道工序";
            }
            that.getselect();
            that.$limits.dragControllerDiv();
            //that.intidata();
            that.confirmAdd();
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1009]"),this.$t("getapi[14]"));
            },
            colsort(){
                let that = this;
                that.$loadviewfields.Fileds('SALShipNoteMasterHeadViewInfo',0,PFileds=>{
                that.tableHeader=PFileds;		
            });	
            },
            sortclick(val){
                if(val==1){
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable(){
                this.$refs.ctab.clearInputs(true);
            },
            tableRowClassName({ row, rowIndex }) {
                let that = this
                row.index = rowIndex;
                if(that.formInline.Head.statusname == '生成'){
                    if(row.qty_delivered > row.qty_onhand){
                        return 'red'
                    }
                }
            },
            //按钮操作权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel',true);
                if(!this.$limits.menuvisible("plv2", 110, 1)){
                    if (that.$limits.authority('plv2', 108, 1) == 1) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }

                    //操作权
                    let ilimits = that.$limits.OperationAuthorityView('plv2', 108, 1, that.total);
                    // limits说明：、1 查询级、2 编辑权限、3 删除权限
                    switch (ilimits) {
                        case -1:
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export,print');
                            break;
                        case 1:
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export,print');
                            break;
                        case -2:
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,execute,import');
                            break;
                        case 2:
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,execute,import');
                            break;
                        case -3:
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,execute,import');
                            break;
                        case 3:
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,execute,import');
                            break;
                        default:
                            break;
                    }
                } else {
                    if (that.$limits.authority('plv2', 110, 1) == 1) {
                        //只读权
                        if (!that.$limits.fnIsEmpty(that.formInline.Head.exclusively_id)) {
                            that.$refs.SetBtn.SetButtonEnable('refresh,search,export,print');
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('refresh,search,export');
                        }

                    }
                    if (that.$limits.authority('plv2', 110, 1) == 2) {
                        if (that.$limits.authority('plv3', 110, 1) == 0) {
                            if (!that.$limits.fnIsEmpty(that.formInline.Head.exclusively_id)) {
                                that.$refs.SetBtn.SetButtonEnable('refresh,search,export,print');
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('refresh,search,export');
                            }
                        }
                        //操作权
                        if (that.$limits.authority('plv3', 110, 1) == 1) {
                            //编辑级
                            if (!that.$limits.fnIsEmpty(that.formInline.Head.exclusively_id)) {
                                if (that.formInline.Head.status > 0) {
                                    that.$refs.SetBtn.SetButtonEnable('search,create,refresh,print,export,import,print');
                                } else {
                                    that.$refs.SetBtn.SetButtonEnable('search,create,save,refresh,export,import,print');
                                }
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('search,create,save,refresh,export,import');
                            }
                        }
                        if (that.$limits.authority('plv3', 110, 1) == 2) {
                            //删除级
                            if (!that.$limits.fnIsEmpty(that.formInline.Head.exclusively_id)) {
                                if (that.formInline.Head.status > 0) {
                                    that.$refs.SetBtn.SetButtonEnable('search,create,save,refresh,export,import,print');
                                } else {
                                    that.$refs.SetBtn.SetButtonEnable('search,create,save,refresh,del,export,import,print');
                                }
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('search,create,save,refresh,export,import');
                            }
                        }
                    }
                }
                // if(that.formInline.Head.status == 2){
                //     that.$refs.SetBtn.SetOneBtnEnable('save', false);
                // }
                if (that.formInline.Head.status > 0) {
                    if(that.$limits.authority('plv4', 566, 1) ==  1){
                        that.updateInvQty = true
                    } else {
                        that.updateInvQty = false
                    }
                    if (that.formInline.Head.status == 2) {
                        that.$refs.SetBtn.SetOneBtnEnable('save', false);
                    } else {
                        that.$refs.SetBtn.SetOneBtnEnable('save', true);
                    }
                }
                that.btnauthority();
                that.rowdelauthority();
            },
            btnauthority() {
                let that = this;
                // 执行权限
                if (that.formInline.Head.status == 0 && that.formInline.Head.exclusively_id != '') {
                    if(this.formInline.Head.negative_flag == 1){
                        if(that.$limits.authority('plv4', 307, 1) != 0){
                            if(this.formInline.Head.finance_status != 2){
                                that.$refs.SetBtn.SetOneBtnEnable('execute', true);
                            } else {
                                that.$refs.SetBtn.SetOneBtnEnable('execute', false);
                            }
                        }
                    } else {
                        if(that.$limits.authority('plv2', 111, 1) != 0){
                            that.$refs.SetBtn.SetOneBtnEnable('execute', true);
                        } else {
                            that.$refs.SetBtn.SetOneBtnEnable('execute', false);
                        }
                    }
                }
                else {
                    that.$refs.SetBtn.SetOneBtnEnable('execute', false);
                }
                that.btn.rowadd = true;
                if (that.formInline.Head.status == 0) {
                    that.btn.rowadd = true;
                }
                else {
                    that.btn.rowadd = false;
                }
                //打印形式发票
                that.btn.prinoice = true;
                if (that.$limits.authority('plv3', 110, 1) == 0) {
                    that.btn.prinoice = false;
                }
                if (that.formInline.Head.status == 0) {
                    that.btn.prinoice = false;
                }

                //从CSV文件生成
                that.btn.csvf = true;
                if (that.$limits.authority('plv3', 110, 1) == 0) {
                    that.btn.csvf = false;
                } else {
                    if (that.$limits.authority('plv4', 57, 1) == 0) {
                        that.btn.csvf = false;
                    } else {
                        if (!that.$limits.fnIsEmpty(that.formInline.Head.customer_order)) {
                            that.btn.csvf = false;
                        }
                        if (that.formInline.Head.status != 0) {
                            that.btn.csvf = false;
                        }
                        ////红字
                        if (that.formInline.Head.negative_flag == 1) {
                            that.btn.csvf = false;
                        }
                        if (!that.$limits.fnIsEmpty(that.formInline.Head.customer_order)) {
                            //销售类型 0 常规销售 、 1 委托销售
                            if (that.formInline.Head.consignment_flag == 0) {
                                that.btn.csvf = false;
                            }
                        }

                    }
                }

                //从通知生成
                if (!that.$limits.fnIsEmpty(that.formInline.Head.customer_order)) {
                    that.btn.notic = true;

                    if (that.$limits.authority('plv3', 110, 1) == 0) {
                        that.btn.notic = false;
                    } else {
                        if (that.$limits.authority('plv4', 57, 1) == 0) {
                            that.btn.notic = false;
                        } else {
                            if (that.formInline.Head.status != 0) {
                                that.btn.notic = false;
                            }
                            ////红字
                            if (that.formInline.Head.negative_flag == 1) {
                                that.btn.notic = false;
                            }
                            //销售类型 0 常规销售 、 1 委托销售
                            if (that.formInline.Head.consignment_flag == 1) {
                                that.btn.notic = false;
                            }
                        }
                    }
                }
                if(that.formInline.Lists.length>0){
                    that.btn.notic = false;
                }

                //确认关闭
                that.btn.closse = true;
                if (that.$limits.authority('plv3', 110, 1) == 0) {
                    that.btn.closse = false;
                } else {
                    if (that.$limits.authority('plv4', 58, 1) == 0) {
                        that.btn.closse = false;
                    } else {
                        if (that.formInline.Head.status != 1) {
                            that.btn.closse = false;
                        }
                    }
                }

                //执行记账
                // console.log('权限状态：' + that.formInline.Head.finance_status);
                if (!that.$limits.fnIsEmpty(that.formInline.Head.exclusively_id)) {
                    that.btn.execu = true;
                    switch (that.formInline.Head.finance_status) {
                        case -1:
                            that.btn.execu = false;
                            break;
                        case 0:
                            that.btn.execu = true;
                            break;
                        case 1:
                            that.btn.execu = false;
                            break;
                        case 2:
                            that.btn.execu = false;
                            break;
                        default:
                            that.btn.execu = false;
                            break;
                    }
                }
                //生成红字发货单
                that.btn.creatred = true;
                ////红字
                if (that.formInline.Head.negative_flag == 1) {
                    that.btn.creatred = false;
                }
                if (that.formInline.Head.status == 0) {
                    that.btn.creatred = false;
                }

                //执行红字发货单 //默认-1 0核算 1记账 2月结
                that.btn.exered = true;

                if (that.formInline.Head.finance_status == 2) {
                    that.btn.exered = false;
                }
                if (that.$limits.authority('plv4', 307, 1) == 0) {
                    that.btn.exered = false;
                } else {
                    if (that.formInline.Head.status != 0) {
                        that.btn.exered = false;
                    }
                }
                //蓝字
                if (that.formInline.Head.negative_flag == 0) {
                    that.btn.exered = false;
                }

                //调整财务日期
                that.btn.changdata = true;
                //默认-1 0核算 1记账 2月结
                if (that.formInline.Head.finance_status == 2) {
                    that.btn.changdata = false;
                }
                if (that.$limits.authority('plv4', 302, 1) == 0) {
                    that.btn.changdata = false;
                } else {
                    if (that.formInline.Head.status != 2) {
                        that.btn.changdata = false;
                    }
                }
                that.rowdelauthority();
            },
            
            handleErrorfile(err, file, outfileList) {
                let that = this;
                // that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
                // 更新文件列表状态
                const index = this.outfileList.findIndex(f => f.uid === file.uid)
                if (index !== -1) {
                    this.outfileList[index].status = 'fail'
                }                
                this.$message.error(`文件 ${file.name} 上传失败`)                
                // 继续上传下一个文件
                this.currentUploadIndex++
                setTimeout(() => {
                    this.uploadNextFile()
                }, 500)
            },
            handleRemovefile(file, outfileList) {
                console.log(file, outfileList);
            },
            handlePreviewfile(file) {
                let that = this;
                console.log("上传2");
                that.outfileparm.code = that.formInline.Head.exclusively_id;
                that.userData = sessionStorage.getItem('userData');
                const key = generatekey(8); // 也可直接指定key let key = 'des';
                that.outfileparm.Login_Group=encryptDes(JSON.parse(that.userData).Login_Group,key);
                that.outfileparm.Login_DB=encryptDes(JSON.parse(that.userData).Login_DB,key);
            },
            beforeAvatarUploadfile(file) {
                let that = this;
                that.outfileparm.code = that.formInline.Head.exclusively_id;
                if (that.formInline.Head.exclusively_id == '' || that.formInline.Head.exclusively_id == null) {
                    that.$message.error(that.$t('getapi[8619]'));//单据号不能为空
                    return false;
                }
                that.userData = sessionStorage.getItem('userData');
                const key = generatekey(8); // 也可直接指定key let key = 'des';
                that.outfileparm.Login_Group=encryptDes(JSON.parse(that.userData).Login_Group,key);
                that.outfileparm.Login_DB=encryptDes(JSON.parse(that.userData).Login_DB,key);
                const isLt10M = file.size / 1024 / 1024 < 10
                if (!isLt10M) {
                    that.$message.error(`文件 ${file.name} 大小不能超过10MB!`)
                    return false
                }
                
                that.outfileparm.currentFileName = file.name
                that.outfileparm.currentFileIndex = that.currentUploadIndex
                
                return true;
            },
            // 手动上传文件
            submitUpload() {
                if (this.outfileList.length === 0) {
                    this.$message.warning(this.$t('getapi[2054]'))
                    return
                }                
                if (this.uploading) {
                    this.$message.warning(this.$t('getapi[13272]'))
                    return
                }                
                this.startUploadQueue()
            },            
            // 开始上传队列
            startUploadQueue() {
                if (this.outfileList.length === 0) return                
                this.uploading = true
                this.uploadQueue = [...this.outfileList] // 复制文件列表到上传队列
                this.currentUploadIndex = 0
                
                this.uploadNextFile()
            },            
            // 上传下一个文件
            uploadNextFile() {
                if (this.currentUploadIndex >= this.uploadQueue.length) {
                    // 所有文件上传完成
                    this.uploading = false
                    this.$message.success(this.$t('getapi[13271]'))
                    // / 清空文件列表
                    this.clearFileList();
                    return
                }
                
                const currentFile = this.uploadQueue[this.currentUploadIndex]
                
                // 设置当前文件的上传参数（如果需要）
                this.outfileparm.currentFileName = currentFile.name
                this.outfileparm.currentFileIndex = this.currentUploadIndex
                this.outfileparm.totalFiles = this.uploadQueue.length
                
                // 手动触发当前文件的上传
                this.$refs.upload.submit()
            },
            // 清空文件列表
            clearFileList() {
                this.uploading = false
                this.outfileList = []
                this.uploadQueue = []
                this.currentUploadIndex = 0
                this.getdlist(this.formInline.Head.exclusively_id);
            },
            handleChangefile(file, fileList) {
                let that = this;
                console.log('------handleChange---', file);
                this.outfileList = fileList
            },
            handleSuccessfile(res, file, outfileList) {
                let that = this;
                console.log('------handleSuccess---', res);
                // 更新文件列表状态
                const index = this.outfileList.findIndex(f => f.uid === file.uid)
                if (index !== -1) {
                    that.outfileList[index].status = 'success'
                    // this.outfileList[index].url = res.url // 假设返回数据中有url
                }
                
                // 上传下一个文件
                that.currentUploadIndex++
                setTimeout(() => {
                    that.uploadNextFile()
                }, 500) // 添加短暂延迟，避免请求过于密集
            },
            openfile(row) {
                let that = this;
                const key = generatekey(8); // 也可直接指定key let key = 'des';
                that.loading = true;
                that.userData = sessionStorage.getItem('userData');
                let parm = {
                    Login_Group: encryptDes(JSON.parse(that.userData).Login_Group,key),
                    Login_DB: encryptDes(JSON.parse(that.userData).Login_DB,key),
                    CType:row.row.ConfigType,
                    OthInfo:'',
                    NodeId:row.row.Node_ID,
                };
                console.log(parm);
                that.$http.urlfilepost(row.row.HttpPost,'/Files/GetFileUrl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl =res.DataContent;
                        window.open(hrefurl);
                    }
                    that.loading = false;
                });
            },
            //删除文件
            filedel(row) {
                let that = this;
                let index = row.$index;
                that.ids = '';
                that.$confirm(that.$t('getapi[8599]'), that.$t('getapi[194]'), {//此操作将永久删除该文件, 是否继续?
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let src = typeof row.row.path == 'undefined' ? '' : row.row.path;
                        let parm = {
                            ids: row.row.Node_ID,
                            FilesSrc: src
                        };
                        that.$http.urlpost('/Basic/DeleteFileByDocManageID', parm, res => {
                            if (res.Success == 1) {
                                that.$message.success(that.$t('getapi[659]'));//'删除成功'
                                that.formInline.outfileList.splice(index, 1);
                            }
                        });
                    })
                    .catch(() => {
                    });
            },
            //明细行删除权限
            rowdelauthority() {
                let that = this;
                that.btn.rowdel = false;
                // console.log('lineid' + that.lineid.length)
                if (that.lineid.length > 0) {
                    //删除明细
                    that.btn.rowdel = true;
                    if (that.$limits.authority('plv3', 110, 1) == 0) {
                        that.btn.rowdel = false;
                        return;
                    } else {
                        if (that.$limits.authority('plv4', 56, 1) == 0) {
                            that.btn.rowdel = false;
                            return;
                        } else {
                            if (that.formInline.Head.status != 0) {
                                that.btn.rowdel = false;
                            }
                        }
                    }
                }
                that.btn.upload = false
                if (that.selectData.length > 1) {
                    // console.log('6666' + that.selectData[0].vender_code)
                    that.btn.upload = that.selectData.every(val => {
                        return val.print_no != null && that.selectData[0].print_no != '' && val.print_no == that.selectData[0].print_no;
                    });
                } else if (that.selectData.length == 1) {
                    if (that.selectData[0].print_no != null && that.selectData[0].print_no != '') {
                        that.btn.upload = true
                    }
                }
                that.btn.delprint = false
                if(that.selectData.length == 1 && !that.$limits.fnIsEmpty(that.selectData[0].print_no)){
                    that.btn.delprint = true
                }
            },
            //tabs
            handleClick(tab, event) {
                this.SelectIndex = tab.name;
                this.intidata();
            },
            // 销售员
            peop(e) {
                this.roushowindex = e;
                if (e == 6) {
                    this.$refs.inputemp1.clearInput(true);
                } else {
                    this.$refs.inputemp2.clearInput(true);
                }
            },
            getemployee(e) {
                if (this.roushowindex == 6) {
                    this.formInline.Head.delivery_person = e.name;
                }
                if (this.roushowindex == 5) {
                    this.formInline.Head.keep_person = e.name;
                }
                if (this.roushowindex == 4) {
                    this.formInline.Head.regist_person = e.name;
                }
            },
            //获取查询条件
            serclick(val) {
                // console.log(val);
                this.queryData = val;
                this.intidata();
            },
            //订单
            conopen() {
                this.$refs.inputs.clearInput(true);
            },
            //获取订单信息
            getsalorder(val) {
                let that = this
                console.log(val);
                this.formInline.Head.contract_info = val.contract_info;
                this.formInline.Head.customer_order = val.customer_order;
                this.formInline.Head.customer_name = val.customer_name;
                this.formInline.Head.consignment_flag = val.consignment_flag == '常规销售' ? 0 : 1;
                this.formInline.Head.delivery_address = val.delivery_address;
                this.formInline.Head.delivery_leadtime = val.delivery_leadtime;
                this.formInline.Head.issue_part_flow = val.issue_part_flow == '是' ? 1 : 0;
                this.formInline.Head.transport_type = val.transport_type;
                this.formInline.Head.Address_ShortName_Id = val.Address_ShortName_Id;
                this.formInline.Head.currency_code_id = val.currency_code_id;
                that.getInfoCustomerID(val.customer_order)
                this.btnauthority();
            },
            getInfoCustomerID(val){
                let that = this
                let parm = {
                    customer_order:  val
                }
                that.$http.urlpost('/Sal/Out/GetSALCustomerInfoShipByCustomerID', parm, function (res) {
                    if (res.Success == 1) {
                        that.AddressShort = res.DataContent;
                    }
                })
            },
            // T通过地址简称获取交货信息详情信息
            getShortNameInfo(val){
                let that = this
                let parm = {
                    Customer_Order: that.formInline.Head.customer_order,
                    Exclusively_ID: val
                }
                that.$http.urlpost('/Sal/Out/GetSALCustomerInfoShipByAddrShortName', parm, function (res) {
                    if (res.Success == 1) {
                        if(res.DataContent[0]){
                            that.formInline.Head.contract_info = res.DataContent[0].Delivery_Contract
                            that.formInline.Head.transport_type = res.DataContent[0].Transport_Type
                            that.formInline.Head.delivery_leadtime = res.DataContent[0].Delivery_Leadtime
                            that.formInline.Head.delivery_address = res.DataContent[0].Delivery_Address
                            that.formInline.Head.remark = res.DataContent[0].Remark
                        }
                    }
                });
            },
            //销售件
            ssf(row) {
                let that = this
                that.partype = 0;
                if (that.formInline.Head.customer_order) {
                    that.wcentershowindex = row.$index;
                    let param = {
                        isnegative: that.formInline.Head.negative_flag,
                        customer_order: that.formInline.Head.customer_order,
                        ordernobase: that.formInline.Head.base_order_no,
                        status: that.formInline.Head.status,
                        consignment_flag: that.formInline.Head.consignment_flag == 1?"委托销售":"常规销售",
                    }
                    that.oneormore = 2
                    // console.log(param)
                    that.$refs.inputsingle.clearInput(true, param);
                } else {
                    that.$message.error(this.$t('getapi[2824]'));
                }
            },
            //获取销售件信息
            getsalpart(val) {
                let checkt = true;
                let that = this;

                if (that.partype == 0) {
                    // console.log(val)
                   if(that.oneormore == 1){
                       val = val.filter(item => {
                           return that.formInline.Lists.every(item2 => {
                               return item.co_line_id != item2.co_line_id
                           });
                       });
                       that.dataDetailLineNo = 1
                       for (let i = 0; i < that.formInline.Lists.length; i++) {
                           if (that.formInline.Lists[i].line_no >= that.dataDetailLineNo) {
                               that.dataDetailLineNo = that.formInline.Lists[i].line_no + 1
                           }
                       }
                       for(let i = 0;i< val.length;i++){
                           that.formInline.Lists = [...that.formInline.Lists,{
                               exclusively_id: '',
                               relation_id: '',
                               pnid:val[i].notice_no,
                               line_no: that.dataDetailLineNo++,
                               sales_part_id: val[i].sales_part_id,
                               sales_part: val[i].sales_part,
                               part_name: val[i].part_name,
                               part_cur_version: val[i].part_version,
                               co_line_id: val[i].co_line_id,
                               co_line_no: val[i].co_line_no,
                               pn_line_id: val[i].pn_line_id,
                               pn_line_no: val[i].notice_num,
                               qty_delivered: '',
                               qty_onhand: '',
                               sales_unit: val[i].sales_unit,
                               unit_price: '',
                               line_net_total_amount: '',
                               t_cuspart_id: '',
                               exchange_rate: val[i].exchange_rate,
                               customer_item: val[i].customer_item,
                               already_invoice_qty: '',
                               inv_measureunit: val[i].inv_unit,
                               inv_measure_issue_qty: '',
                               pnqty: val[i].qty,
                               issue_material_unit: '',
                               issue_man_unit: '',
                               issue_charge_unit: '',
                               issue_material_amount: '',
                               issue_man_amount: '',
                               issue_charge_amount: '',
                               releaseinvoiceqty: '',
                               createinvoiceqty: '',
                               remark2: val[i].remark2,
                               itemvernum:val[i].itemvernum,
                               cus_chartnum:val[i].cus_chartnum,
                               spec:val[i].spec,
                               model:val[i].model,                               
                               page_no:val[i].page_no,  
                               isadd: 1
                           }]
                       }
                   } else {
                       for (let i = 0; i < that.formInline.Lists.length; i++) {
                            if (val.co_line_id == that.formInline.Lists[i].co_line_id) {
                                return false
                            }
                        }
                       that.formInline.Lists[that.wcentershowindex].exclusively_id= '';
                       that.formInline.Lists[that.wcentershowindex].relation_id= '';
                       that.formInline.Lists[that.wcentershowindex].pnid= val.notice_no
                       that.formInline.Lists[that.wcentershowindex].line_no= that.formInline.Lists.length + 1;
                       that.formInline.Lists[that.wcentershowindex].sales_part_id= val.sales_part_id;
                       that.formInline.Lists[that.wcentershowindex].sales_part= val.sales_part;
                       that.formInline.Lists[that.wcentershowindex].part_name= val.part_name;
                       that.formInline.Lists[that.wcentershowindex].part_cur_version= val.part_version;
                       that.formInline.Lists[that.wcentershowindex].co_line_id= val.co_line_id;
                       that.formInline.Lists[that.wcentershowindex].co_line_no= val.co_line_no;
                       that.formInline.Lists[that.wcentershowindex].pn_line_id= val.pn_line_id;
                       that.formInline.Lists[that.wcentershowindex].pn_line_no= val.notice_num;
                       that.formInline.Lists[that.wcentershowindex].qty_delivered= '';
                       that.formInline.Lists[that.wcentershowindex].qty_onhand= '';
                       that.formInline.Lists[that.wcentershowindex].sales_unit= val.sales_unit;
                       that.formInline.Lists[that.wcentershowindex].unit_price= '';
                       that.formInline.Lists[that.wcentershowindex].line_net_total_amount= '';
                       that.formInline.Lists[that.wcentershowindex].t_cuspart_id= '';
                       that.formInline.Lists[that.wcentershowindex].exchange_rate= val.exchange_rate;
                       that.formInline.Lists[that.wcentershowindex].customer_item= val.customer_item;
                       that.formInline.Lists[that.wcentershowindex].already_invoice_qty= '';
                       that.formInline.Lists[that.wcentershowindex].inv_measureunit= val.inv_unit;
                       that.formInline.Lists[that.wcentershowindex].inv_measure_issue_qty= '';
                       that.formInline.Lists[that.wcentershowindex].pnqty= val.qty;
                       that.formInline.Lists[that.wcentershowindex].issue_material_unit= '';
                       that.formInline.Lists[that.wcentershowindex].issue_man_unit= '';
                       that.formInline.Lists[that.wcentershowindex].issue_charge_unit= '';
                       that.formInline.Lists[that.wcentershowindex].issue_material_amount= '';
                       that.formInline.Lists[that.wcentershowindex].issue_man_amount= '';
                       that.formInline.Lists[that.wcentershowindex].issue_charge_amount= '';
                       that.formInline.Lists[that.wcentershowindex].releaseinvoiceqty= '';
                       that.formInline.Lists[that.wcentershowindex].createinvoiceqty= '';
                       that.formInline.Lists[that.wcentershowindex].remark2= val.remark2;
                       that.formInline.Lists[that.wcentershowindex].itemvernum= val.itemvernum;
                       that.formInline.Lists[that.wcentershowindex].cus_chartnum= val.cus_chartnum;
                       that.formInline.Lists[that.wcentershowindex].spec= val.spec;
                       that.formInline.Lists[that.wcentershowindex].model= val.model;
                       that.formInline.Lists[that.wcentershowindex].page_no= val.page_no;                      
                       
                       that.formInline.Lists[that.wcentershowindex].isadd= 0
                   }
                } else {
                    this.getdetils(val);
                }
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = '';
                that.selectData = val;
                for (let i = 0; i < val.length; i++) {
                    that.selectIDData += val[i].Co_id + ',';
                }
                that.rowdelauthority();
                // console.log(that.selectIDData);
            },

            //批量删除
            delall() {
                let that = this;
                that.ids = this.selectIDData;
                that.$confirm(that.$t('getapi[8594]'), that.$t('getapi[194]'), {//'此操作将永久删除该发货单, 是否继续?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            exclusively_id: that.formInline.Head.exclusively_id,
                            customer_order: that.formInline.Head.customer_order,
                            status: that.formInline.Head.status,
                            concurrent_time: that.formInline.Head.concurrent_time
                        };
                        that.$http.urlpost('/Sal/Out/DelSalShipNote', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.intidata();
                                that.confirmAdd();
                            }
                        });

                    })
                    .catch(() => {
                    });
            },
            //新增一行工艺清单
            addline(line) {
                let that = this;
                if (line >= 0) {
                    that.formInline.Lists[line].add = true;
                    let detail = that.formInline.Lists;
                    let deti = {};
                    let jss = detail[detail.length - 1].add;
                    if (jss) {
                        that.formInline.Lists.push(deti);
                    }
                } else {
                    let deti = {
                        add: true,
                        exclusively_id: 0,
                        relation_id: '',
                        line_no: 0,
                        sales_part_id: 0,
                        sales_part: '',
                        part_name: '',
                        part_cur_version: '',
                        co_line_id: 0,
                        co_line_no: 0,
                        pn_line_id: 0,
                        pn_line_no: 0,
                        qty_delivered: 0,
                        qty_onhand: 0,
                        sales_unit: '',
                        unit_price: 0,
                        line_net_total_amount: 0,
                        t_cuspart_id: '',
                        exchange_rate: 0,
                        customer_item: '',
                        already_invoice_qty: 0,
                        inv_measureunit: '',
                        inv_measure_issue_qty: 0,
                        pnqty: 0,
                        issue_material_unit: 0,
                        issue_man_unit: 0,
                        issue_charge_unit: 0,
                        issue_material_amount: 0,
                        issue_man_amount: 0,
                        issue_charge_amount: 0,
                        releaseinvoiceqty: 0,
                        createinvoiceqty: 0,
                        isadd: 0
                    };
                    that.formInline.Lists.push(deti);
                }
            },
            //修改页数
            handleSizeChange(val) {
                this.PageSize = val;
                this.$http.savePageSize('SALShipNoteMasterHeadViewInfo',val);
                this.intidata();
                this.authority();
            },
            //跳页
            handleCurrentChange(val) {
                this.PageIndex = val;
                this.intidata();
                this.authority();
            },
            //编辑
            // editInfo(row) {
            // 	console.log(row);
            // 	let that = this;

            // },
            // 获取数据
            intidata() {
                let that = this;
                that.loading = true;
                this.isVisible = false;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: '',
                    row_sign: '',
                    query_sort: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: []
                };
                that.queryData.forEach(item => {
                    if (item.query_Condition == '' || item.query_Condition.length > 0) {
                        pm = {
                            row_sign: item.row_sign,
                            query_Condition: item.query_Condition,
                            query_sort: item.query_sort,
                            query_field_type: item.Query_Field_Type,
                            query_field_name: item.Query_Field_Name
                        };
                        parm.Param.push(pm);
                    }
                });
                // console.log(parm);
                that.$http.urlpost('Sal/Out/GetSalInvoiceList', parm, function (res) {
                    // console.log(res);
                    if (res.Success == 1) {
                        that.datajson = res.DataContent;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.loading = false;
                });
            },
            //获取详情
            getdlist(id) {
                let that = this;
                let parm = {
                    Code: id
                };
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('Sal/Out/GetSalShipNoteBillInfo', parm, function (res) {
                    // console.log(res);
                    if (res.Success == 1) {
                        that.formInline = res.DataContent;
                        let stat = res.DataContent.Head.status;
                        if (stat == 1) {
                            that.btn.closse = false;
                        }
                        that.formInline.Lists.forEach(item => {
                            item.add = true;
                        });
                        that.getInfoCustomerID(that.formInline.Head.customer_order)
                        that.oldFormInline = JSON.stringify(that.formInline)
                        that.authority();
                        that.$nextTick(function() {
                            that.$processdata.initFormRight(0)
                        })
                    }
                    loadingInstance.close()
                });
            },
            // 保存数据
            save() {
                let that = this;
                that.loading = true;
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                let parm = that.formInline;
                parm.LangType = that.$processdata.getLang()
                /*parm.Lists.forEach(function (item, index) {
                    if (!item.add) {
                        parm.Lists.splice(index, 1);
                    }
                });*/
                console.log(parm);
                that.$http.urlpost('Sal/Out/SalShipNoteSaveData', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.intidata();
                        that.order_No = res.UniqueNum
                        that.getdlist(res.UniqueNum);
                        that.editvisi = false;
                    }
                    that.loading = false;
                });
            },
            // 编辑
            edit(jsd) {
                console.log(jsd);
                let that = this;
                that.editvisi = true;
                that.editf = false;
                that.order_No = jsd.row.Exclusively_Id
                that.getdlist(that.order_No);
            },
            // 新增
            add() {
                let that = this;
                let datacopy = that.formInline
                for(let i = 0;i<datacopy.Lists.length;i++){
                    delete datacopy.Lists[i]['index']
                }
                if(that.oldFormInline != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this;
                this.formInline = {
                    Head: {
                        exclusively_id: '',
                        customer_order: '',
                        customer_name: '',
                        field: '',
                        delivery_date: '',
                        delivery_person: '',
                        transport_type: '',
                        delivery_leadtime: '',
                        delivery_address: '',
                        create_person: '',
                        create_time: '',
                        status: 0,
                        statusname: '生成',
                        remark: '',
                        hook_flag: 0,
                        finance_status: 0,
                        finance_date: '',
                        base_order_no: '',
                        negative_flag: 0,
                        verify_status: 0,
                        keep_person: this.userinfo.username,
                        regist_person: this.userinfo.username,
                        remark_new: '',
                        update_person: '',
                        update_time: '',
                        order_category: '发货',
                        verify_type: 0,
                        inner_no: '',
                        invoice_flag: 0,
                        concurrent_time: '',
                        carrier_name: '',
                        vehicle_size: '',
                        plate_no: '',
                        cmr_no: '',
                        ekaer_no: '',
                        consignment_flag: 0,
                        issue_part_flow: 0,
                        contract_info: '',
                        Address_ShortName_Id:'',
                        Address_ShortName:'',
                        currency_code_id:'',
                    },
                    Lists: []
                };
                this.editvisi = true;
                that.code = ''
                this.editf = true;
                that.oldFormInline = JSON.stringify(that.formInline)
                this.authority();
            },
            // 查询
            search() {
                this.isVisible = true;
                this.$refs.ser.clearInput(this.isVisible, 'SALShipNoteMasterHeadViewInfo');
            },
            // 刷新
            reflash() {
                /*this.intidata();
                let code = this.formInline.Head.exclusively_id;
                if (code) {
                    this.getdlist(code);
                }*/
                let that = this;
                let datacopy = that.formInline
                for(let i = 0;i<datacopy.Lists.length;i++){
                    delete datacopy.Lists[i]['index']
                }
                if(that.oldFormInline != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            this.intidata();
                            let code = this.formInline.Head.exclusively_id;
                            if (code) {
                                this.getdlist(code);
                            } else {
                                that.confirmAdd()
                            }
                        });
                } else {
                    this.intidata();
                    let code = this.formInline.Head.exclusively_id;
                    if (code) {
                        this.getdlist(code);
                    } else {
                        that.confirmAdd()
                    }
                }
            },
            //弹出框关闭前提示
            closemodel(e) {
                let that = this
                this.$confirm(that.$t('getapi[3655]'), that.$t('getapi[194]'), {//'数据已发生变更是否保存后关闭?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                    })
                    .catch(() => {
                    });
            },
            //获取下拉数据
            getselect() {
                let that = this;
                let parm = {};
                //运输方式
                that.$http.urlpost('/Basic/Sale/GetTransportTypeList', parm, function (res) {
                    if (res.Success == 1) {
                        that.TransMode = res.DataContent;
                    }
                });
                // 交货条款
                that.$http.urlpost('/Basic/Sale/GetDeliveryTermList', parm, function (res) {
                    if (res.Success == 1) {
                        that.DeliveryTermList = res.DataContent;
                    }
                });
            },
            handleCommand(itemn) {
            },
            // 打印形式发票
            prinoice() {
            },
            // csv
            csvf() {
            },
            // 从通知生成
            notic() {
                let that = this
                if (this.formInline.Head.customer_order) {
                    /*this.$refs.input.clearInput(true, 4, '', this.formInline.Head);*/
                    let param = {
                        Code: that.formInline.Head.customer_order
                    };
                    this.$refs.input4.clearInput(true,param)
                    this.partype = 1;
                } else {
                    this.$message.error(this.$t('getapi[2824]'));
                }
            },
            // 执行记账
            execu() {
                let that = this;
                let parm = {
                    exclusively_id: that.formInline.Head.exclusively_id,
                    status: that.formInline.Head.Status,
                    concurrent_time: that.formInline.Head.concurrent_time
                };
                // console.log(parm);
                that.$http.urlpost('Sal/Out/SalShipNoteFinance', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getdlist(that.order_No);
                    }
                });
            },
            // 生成红字发货单
            creatred() {
                let that = this;
                let parm = {
                    exclusively_id: that.formInline.Head.exclusively_id,
                    status: that.formInline.Head.status,
                    concurrent_time: that.formInline.Head.concurrent_time
                };
                // console.log(parm);
                that.$http.urlpost('Sal/Out/GetSalShipNoteRedLetter', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        let data = res.DataContent
                        that.formInline.IsConfirm = 0
                        that.formInline.Head = data.Head
                        that.formInline.Lists = data.Lists
                        that.formInline.Head.order_category = '退货'
                        that.authority();
                    }
                });
            },
            // 执行红字发货单
            exered() {
                let that = this
                that.$store.commit('setSharedParams', {
                    code: this.formInline.Head.exclusively_id,
                    consignment_flag: this.formInline.Head.consignment_flag == '0' ? '常规销售' : '委托销售',
                    customer_order: this.formInline.Head.customer_order,
                    delivery_person: this.formInline.Head.delivery_person,
                    concurrent_time: this.formInline.Head.concurrent_time,
                    negative_flag: this.formInline.Head.negative_flag,
                    issue_part_flow: this.formInline.Head.issue_part_flow
                });
                if (this.formInline.Head.negative_flag == 1) {
                    let item = {
                        label: '执行红字发货单',
                        name: 'salreturn',
                        path: '/salreturn',
                        url: '/salreturn',
                        icon: 'video-play'
                    };
                    this.$router.push({path: '/salreturn'});
                    this.$store.commit('selectMenu', item);
                    this.$limits.cachePage(item)
                } else {
                    let item = {
                        label: '发货出库执行',
                        name: 'salsend',
                        path: '/salsend',
                        url: '/salsend',
                        icon: 'video-play'
                    };
                    this.$router.push({path: '/salsend'});
                    this.$store.commit('selectMenu', item);
                    this.$limits.cachePage(item)
                }
                this.editvisi = false;
            },
            // 调整财务日期
            changdata() {
            },
            //确认关闭
            closse() {
                let that = this;
                // console.log(that.formInline);
                // return;
                let parm = {
                    exclusively_id: that.formInline.Head.exclusively_id,
                    status: that.formInline.Head.status,
                    concurrent_time: that.formInline.Head.concurrent_time
                };
                that.$http.urlpost('Sal/Out/SalShipNoteClose', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getdlist(res.UniqueNum);
                    }
                });
            },
            UpdateInvoiceQty() {
                let that = this;
                let parm = {
                    exclusively_id: that.formInline.Head.exclusively_id,
                    customer_order: that.formInline.Head.customer_order,
                    concurrent_time: that.formInline.Head.concurrent_time
                };
                that.$http.urlpost('/Sal/Out/SalUpdateInvoiceQty', parm, function (res) {
                    that.btn.RBalance = true
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getdlist(res.UniqueNum);
                    }
                });
            },
            //根据通知单号获取开单明细
            getdetils(code) {
                let that = this;
                let parm = {
                    Code: code.exclusively_id
                };
                that.$http.urlpost('Sal/Out/GetSalPickNoticeLineByNoteId', parm, function (res) {
                    // console.log(JSON.stringify(res.DataContent.Lists));
                    if (res.Success == 1) {
                        var val = res.DataContent.Lists;
                            if(val.length>0)
                            {
                                val = val.filter(item => {
                                    return that.formInline.Lists.every(item2 => {
                                        return item.co_line_id != item2.co_line_id;
                                    });
                                });
                                that.dataDetailLineNo = 1
                                for (let i = 0; i < that.formInline.Lists.length; i++) {
                                    if (that.formInline.Lists[i].line_no >= that.dataDetailLineNo) {
                                        that.dataDetailLineNo = that.formInline.Lists[i].line_no + 1
                                    }
                                }
                                for(let i=0;i<val.length;i++){
                                    that.formInline.Lists = [...that.formInline.Lists,{
                                        exclusively_id: '',
                                        relation_id: '',
                                        line_no: that.dataDetailLineNo++,
                                        pnid:val[i].pnid,
                                        sales_part_id: val[i].sales_part_id,
                                        sales_part: val[i].sales_part,
                                        part_name: val[i].part_name,
                                        part_cur_version: val[i].part_cur_version,
                                        co_line_id: val[i].co_line_id,
                                        co_line_no: val[i].co_line_no,
                                        pn_line_id: val[i].pn_line_id,
                                        pn_line_no: val[i].pn_line_no,
                                        qty_delivered: '',
                                        qty_onhand: '',
                                        sales_unit: val[i].sales_unit,
                                        unit_price: '',
                                        line_net_total_amount: '',
                                        t_cuspart_id: '',
                                        exchange_rate: val[i].exchange_rate,
                                        customer_item: val[i].customer_item,
                                        already_invoice_qty: '',
                                        inv_measureunit: val[i].inv_unit,
                                        inv_measure_issue_qty: '',
                                        pnqty: val[i].pnqty,
                                        issue_material_unit: '',
                                        issue_man_unit: '',
                                        issue_charge_unit: '',
                                        issue_material_amount: '',
                                        issue_man_amount: '',
                                        issue_charge_amount: '',
                                        releaseinvoiceqty: '',
                                        createinvoiceqty: '',
                                        remark2: val[i].remark2,
                                        itemvernum: val[i].itemvernum,                                        
                                        cus_chartnum: val[i].cus_chartnum,    
                                        spec: val[i].spec,  
                                        model: val[i].model,  
                                        page_no: val[i].page_no,                                        
                                          
                                        isadd: 1
                                    }];
                                }
                            }
                            that.formInline.Lists.forEach(item => {
                                item.add = true;
                            });
                    }
                });
            },
            imp(){
                let item = {
                    //label: '发货单导入',
                    label: '通用导入',
                    name: 'exp',
                    path: '/exp/31',
                    url: '/exp/31',
                    icon: 'video-play'
                };
                this.$router.push({path: '/exp/31'});
                this.$store.commit('selectMenu', item);
            },
            //导出·
            exp() {
                /*let that = this;
                that.loading = true;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: '',
                    row_sign: '',
                    query_sort: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: that.selectIDData,
                    Param: []
                };
                that.queryData.forEach(item => {
                    if (item.query_Condition == '' || item.query_Condition.length > 0) {
                        pm = {
                            row_sign: item.row_sign,
                            query_Condition: item.query_Condition,
                            query_sort: item.query_sort,
                            query_field_type: item.Query_Field_Type,
                            query_field_name: item.Query_Field_Name
                        };
                        parm.Param.push(pm);
                    }
                });
                // console.log(JSON.stringify(parm));
                that.$http.urlpost('Sal/Out/GetSalInvoiceListToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    } else {
                        that.$message.error(res.Msg);
                    }
                    that.loading = false;
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "SALShipNoteMasterHeadViewInfo",
                    fromname: that.$t('getapi[1009]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            //打印
            print() {
                //判断状态
                let that = this;
                let parm = {
                    Code:'SAL_Ship_Note_Master'
                }
                that.$http.urlpost('/Basic/GetPrintTemplates', parm, function (res) {
                    if (res.Success == 1) {
                        that.visDetailPrintType = true
                        that.dataPrint = res.DataContent
                    }
                });
            },
            changePrint(val,code){
                let that = this
                that.tempname = code
            },
            confirmPrint(){
                let that = this
                if(that.$limits.fnIsEmpty(that.formInline.Head.exclusively_id)){
                    return;
                }
                that.loading = true;
                let templatename = that.tempname
                let parm = {
                    po_no: that.formInline.Head.exclusively_id,
                    delivery_person: that.formInline.Head.delivery_person,
                    create_time: that.formInline.Head.create_time,
                    cus_name: that.formInline.Head.customer_name,
                    delivery_date: that.formInline.Head.finance_date,
                    TemplateName: templatename
                };
                that.$http.urlpost('/Print/DPrint', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = res.Key;
                        window.open(hrefurl);
                    }
                    that.visDetailPrintType = false
                    that.loading = false;
                });
            },
            deleteOrder(scope) {
                // 删除订单
                // console.log(scope);
                // 无删除接口，暂时不处理
                // let that = this;
                // this.ids = scope.row;
                // that
                //   .$confirm("请确认, 是否继续删除单据?", "提示", {
                //     confirmButtonText: "确定",
                //     cancelButtonText: "取消",
                //     type: "warning",
                //   })
                //   .then(() => {
                //      //
                //   })
                //   .catch(() => {});
            },
            //点击触发详情
            edits(jsd) {
                let that = this;
                if(that.code == jsd.Exclusively_Id){
                    return
                }
                that.timeId = setTimeout(() => {
                    if(!this.$limits.menuvisible("plv2", 110, 1)){
                        return
                    }
                    let datacopy = that.formInline
                    for(let i = 0;i<datacopy.Lists.length;i++){
                        delete datacopy.Lists[i]['index']
                    }
                    if(that.oldFormInline != JSON.stringify(datacopy)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = jsd
                                that.editvisi = true;
                                that.editf = false;
                                that.code = jsd.Exclusively_Id;
                                that.getdlist(that.code);
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = jsd
                        that.editvisi = true;
                        that.editf = false;
                        that.code = jsd.Exclusively_Id;
                        that.getdlist(that.code);
                    }
                }, 100);
            },
            // 详情多选
            linedelsel(e) {
                // console.log(e);
                this.lineid = [];
                for (var i = 0; i < e.length; i++) {
                    this.lineid.push(e[i]);
                }
                this.rowdelauthority();
            },
            //发货明细删除
            dellines() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            exclusively_id: that.formInline.Head.exclusively_id,
                            concurrent_time: that.formInline.Head.concurrent_time,
                            consignment_flag: that.formInline.Head.consignment_flag,
                            Lists: []
                        };

                        for (let i = that.lineid.length - 1; i >= 0; i--) {
                            that.formInline.Lists.splice(that.lineid[i].index, 1);
                            if (!that.$limits.fnIsEmpty(that.lineid[i].exclusively_id)) {
                                let datatmp = {
                                    exclusively_id: that.lineid[i].exclusively_id,
                                    pn_line_id: that.lineid[i].pn_line_id
                                }
                                parm.Lists.push(datatmp);
                            }
                        }
                        if (parm.Lists.length > 0) {
                            that.$http.urlpost('/Sal/Out/DelSalShipNoteDetail', parm, function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    that.getdlist(res.UniqueNum);
                                }else{
                                    that.getdlist(that.formInline.Head.exclusively_id);
                                }

                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            // 新增s
            addlines() {
                let that = this;
                if(that.formInline.Head.customer_order == '' || that.formInline.Head.customer_order == null){
                    that.$message.warning(this.$t('getapi[8775]'));//'销售单号不能为空'
                    return
                }
                that.wcentershowindex = -1
                that.partype = 0
                let param = {
                    isnegative: that.formInline.Head.negative_flag,
                    customer_order: that.formInline.Head.customer_order,
                    ordernobase: that.formInline.Head.base_order_no,
                    status: that.formInline.Head.status,
                    consignment_flag: that.formInline.Head.consignment_flag == 1?"委托销售":"常规销售",
                }
                that.oneormore = 1
                that.$refs.input.clearInput(true, param);
                /*let dlength = that.formInline.Lists.length;
                let detail = that.formInline.Lists;
                let deti = {
                    linid: dlength,
                    add: true,
                    exclusively_id: 0,
                    relation_id: '',
                    line_no: dlength + 1,
                    co_line_id: 0,
                    co_line_no: '',
                    co_line_part: '',
                    part_version: '',
                    co_line_part_id: 0,
                    co_line_inv_part_num: 0,
                    sales_qty: 0,
                    need_deliver_qty: 0,
                    plan_deliver_qty: 0,
                    qty_onhand: 0,
                    qty_onyuliu: 0,
                    create_person: that.userinfo.username,
                    create_time: '',
                    remark: '',
                    status: 0,
                    statusname: '',
                    item_code: '',
                    item_name: '',
                    cuspart_id: '',
                    cuspart_name: '',
                    customer_item: 0,
                    package_size: 0,
                    isadd: 0
                };
                that.formInline.Lists.push(deti);*/
            },

            //拖动条中间快捷按钮
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            //点击键盘触发
            show(ev, row) {
                let that = this;
                that.edit(row);
            },
            //按住键盘触发
            shows(ev, index) {
                let that = this;
                if (ev.keyCode == 38) {
                    let tds = this.datajson[index - 1];
                    this.setCurrent(tds);
                }
                if (ev.keyCode == 40) {
                    let tds = this.datajson[index + 1];
                    this.setCurrent(tds);
                }
            },
            //更新表格行状态
            setCurrent(row) {
                this.$refs.singleTable.setCurrentRow(row);
            },
            getinv_measure_issue_qty(row){
                let that = this
                let index = row.$index
                that.formInline.Lists[index].inv_measure_issue_qty = that.formInline.Lists[index].qty_delivered / that.formInline.Lists[index].exchange_rate
            },
            combinePrint(){
                //判断状态
                let that = this;
                that.visPrintType = true
            },
            updateSignTime(){
                let that = this
                that.printdate = ''
                that.showSignTime = true
            },
            confirmUpdateSignTime(){
                let that = this
                let arr = []
                for(let i = 0;i<that.selectData.length;i++){
                    arr = [...arr, that.selectData[i].Exclusively_Id]
                }
                let parm = {
                    Sign_Time: that.printdate,
                    List: arr
                }
                that.$http.urlpost('/LogCar/SalShipNoteSetSignTime', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.intidata();
                        that.showSignTime = false
                    }
                });
            },
            // 合并打印
            confirmCombinePrint() {
                let that = this
                let template = ''
                let order_type = 0
                let arr = []
                for(let i=0;i<that.selectData.length;i++){
                    arr = [...arr,{
                        order_no: that.selectData[i].Exclusively_Id
                    }]
                }
                if (that.print_model == 0 && that.print_sort == 0) {
                    order_type = 0
                    template = '02送货单_MergeSmall_Auto.xlsx'
                } else if (that.print_model == 1 && that.print_sort == 0) {
                    order_type =1
                    template = '02送货单_MergeSmallTOLEDO_Auto.xlsx'
                } else if(that.print_model == 0 && that.print_sort == 1) {
                    order_type = 2
                    template = '02送货单_MergeSmall_Auto.xlsx'
                } else if(that.print_model == 1 && that.print_sort == 1){
                    order_type =3
                    template = '02送货单_MergeSmallTOLEDO_Auto.xlsx'
                } else if(that.print_model == 2 && that.print_sort == 0){
                    order_type =4
                    template = '30送货单_大和热磁.xlsx'
                } else if(that.print_model == 2 && that.print_sort == 1){
                    order_type =5
                    template = '30送货单_大和热磁.xlsx'
                } else if(that.print_model == 3 && that.print_sort == 0){
                    order_type =6
                    template = '02送货单_GMS_Auto.xlsx'
                } else if(that.print_model == 3 && that.print_sort == 1){
                    order_type =7
                    template = '02送货单_GMS_Auto.xlsx'
                } else if(that.print_model == 4 && that.print_sort == 0){
                    order_type =8
                    template = '02送货单_XK_Auto.xlsx'
                } else if(that.print_model == 4 && that.print_sort == 1){
                    order_type =9
                    template = '02送货单_XK_Auto.xlsx'
                }
                let parm = {
                    TemplateName: template,
                    Order_type: order_type,
                    ls: arr
                };
                that.$http.urlpost('/Print/DMergePrint', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = res.Key;
                        window.open(hrefurl);
                        that.visPrintType = false
                    }
                });
            },
            // 查询回单
            lct(row){
                let that = this
                let parm = {
                    print_no: row.row.print_no
                }
                that.$http.urlpost('/LogCar/GetLogCarByPrintNo', parm, function (res) {
                    if (res.Success == 1) {
                        that.printData = res.DataContent
                        that.showPrintData = true
                    }
                });
            },
            // 查看文件
            open(url){
                window.open(url);
            },
            // 上传附件
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                let that =this
                console.log("handlePreview"+file);
            },
            handleChange(file, fileList) {
                let that = this;
                that.file = file.raw
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    console.log('导入成功')
                }
                that.fileList=[];
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },
            uploadFile(){
                let that = this;
                let datetime = Common.methods.getDatetime()
                that.userData = sessionStorage.getItem('userData');
                const key = generatekey(8); // 也可直接指定key let key = 'des';
                let formData = new FormData(); //formdata格式
                formData.append('file', that.file);
                formData.append('print_no', that.selectData[0].print_no)
                formData.append('Login_Group', encryptDes(JSON.parse(that.userData).Login_Group,key))
                formData.append('Login_DB', encryptDes(JSON.parse(that.userData).Login_DB,key))
               /* that.$http.urlpost('/LogShip/UploadFilesReceiptByShipNote', formData, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.fileList=[];
                    }
                });*/
                $.ajax({
                    url: Common.FileUrlA88 + '/LogShip/UploadFilesReceiptByShipNote' + '?token=' + JSON.parse(that.userData).token,
                    type: 'post',
                    data: formData,
                    async: false,
                    contentType: false,
                    processData: false,
                    success: function (res) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.fileList=[];
                    },
                    error: function (xhr, errorType, error) {
                        //
                    }
                });
            },
            // 删除打印码
            delPrint() {
                let that = this
                that.$confirm(that.$t('getapi[8776]'), that.$t('getapi[194]'), {//确定删除打印码
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            Code: that.selectData[0].print_no,
                            LangType: that.$processdata.getLang(),
                        }
                        that.$http.urlpost('/Sal/Out/ClearLastPrintNo', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.intidata()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[6096]')
                        });
                    });
            },
            expStatus(val){
                let that = this
                if(val == 0){
                    return that.$t('getapi[1422]')//'生成'
                } else if(val == 1){
                    return that.$t('getapi[2868]')//'发出'
                } else if(val == 2){
                    return that.$t('getapi[441]')//'关闭'
                } else {
                    return ''
                }
            },
            checkDataChange(){
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 110,1) < 1){
                    return false
                }
                let datacopy = that.formInline
                for(let i = 0;i<datacopy.Lists.length;i++){
                    delete datacopy.Lists[i]['index']
                }
                let flag =  that.oldFormInline != JSON.stringify(datacopy)
                return flag
            },
            // 排序
            sortChange(column){
                let that = this
                that.$processdata.sortChange(column,that.formInline.Lists)
            }
        }
    };
</script>

<style scoped lang="less">
    /deep/ .red {
        background: #ff7879;
    }
    .el-dropdown {
        vertical-align: top;
        background-color: #ffd04b !important;
        border-color: #ffd04b !important;
        color: #ffffff;
        margin-left: 20px;
        padding: 0 14px;
        border-radius: 5px;
    }

    .el-dropdown + .el-dropdown {
        margin-left: 15px;
    }

    .el-icon-arrow-down {
        font-size: 12px;
    }

    span.title {
        width: 100%;
        display: flex;
        height: 40px;
        line-height: 40px;
    }

    span.title .el-switch {
        display: inline-block;
        margin: 8px 30px;
    }

    .box {
        width: 100%;
        overflow-x: auto;
        .bbl {
            margin: 0px auto;
            white-space: pre;
            span {
                margin-left: 10px;
                min-width: 70px;
                text-align: left;
                line-height: 30px;
                display: inline-block;
                margin-right: 0px;
            }
        }
    }

    span.titles {
        margin-left: 14px;
        margin-right: 15px;
        text-align: left;
        line-height: 40px;
        display: inline-block;
    }

    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
  
    
</style>
